import React, { JSX } from 'react';
import styled from '@emotion/styled';

export enum PlaceholderSize {
  NORMAL = 'normal',
  NARROW = 'narrow'
}

export interface P {
  size?: PlaceholderSize;
  background?: boolean;
  color?: string;
  text?: string;
  children?: React.ReactNode;
}

export const Placeholder = (props: P): JSX.Element => {
  const { text, children, background, color, size } = props;

  const pBackground = background !== undefined ? background : true;
  const pColor = color || 'grey';
  const pSize = size || PlaceholderSize.NORMAL;

  const fontSize = pSize === PlaceholderSize.NORMAL ? '1.5rem' : '1rem';
  const padding = pSize === PlaceholderSize.NORMAL ? '1rem 1rem' : '0';

  const Border = styled.div`
    position: relative;
    border: solid 3px ${pColor};
    color: ${pColor};
    padding: ${padding};
    border-top-left-radius: 255px 15px;
    border-top-right-radius: 15px 255px;
    border-bottom-right-radius: 225px 15px;
    border-bottom-left-radius: 15px 255px;
  `;

  const Background = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: ${pColor};
    opacity: 0.1;
  `;

  const Text = styled.div`
    font-size: ${fontSize};
  `;

  return (
    <Border>
      {pBackground && <Background />}
      <Text className="m-0 text-center">{text}</Text>
      {children}
    </Border>
  );
};
